import { AddressSelectorContainer } from './AddressSelectorContainer';
export default AddressSelectorContainer;
